import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../../store/AuthContext';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const { buscaToken } = React.useContext(AuthContext);
  const [erro, setErro] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    async function validaServiceTicket() {
      const pegouToken = await buscaToken(searchParams.get('ticket'));
      const origem = searchParams.get('origem');
      const redirect = searchParams.get('redirect');
      if (pegouToken) {
        if(origem === 'app'){
          localStorage.setItem('origem',origem);
          if(redirect){
            navigate(`/${redirect}`);
          }else{
            navigate('/principal');
          }
        }else{
          navigate(localStorage.getItem('pathAfterLogin') || '/');
        }
      } else {
        setErro(true);
        if(origem === 'app'){
          localStorage.setItem('origem',origem);
          navigate('/erroApp');
        }
      }
    }
    validaServiceTicket();
  }, []);

  return (
    <>
      {!erro && <div>Obtendo token de acesso ...</div>}
      {erro && <div>Erro ao obter token de acesso ...</div>}
    </>
  );
};

export default AuthCallback;
